/* eslint-disable */
/*
 * Chartist.js plugin to display anti-target KR progress chart
 *
 */
(function (factory) {
  if (typeof define === "function" && define.amd) {
    define(["chartist"], factory);
  } else if (typeof module === "object" && module.exports) {
    module.exports = factory(require("chartist"));
  } else {
    factory((typeof global !== "undefined" ? global : window).Chartist);
  }
})(function (Chartist) {
  "use strict";

  var defaultOptions = {
    above: true,
    target: 0,
    critical: 0,
  };

  Chartist.plugins = Chartist.plugins || {};
  Chartist.plugins.ctKrRectangles = function (options) {
    options = Chartist.extend({}, defaultOptions, options);

    return function ctKrRectangles(chart) {
      if (chart instanceof Chartist.Line || chart instanceof Chartist.Bar) {
        chart.on("created", function (data) {
          // bottom rectangle top left corner
          var bottomValue = options.above ? options.critical : options.target;
          // middle rect top left corner
          var middleValue =
            options.critical === options.target
              ? null
              : options.above
              ? options.target
              : options.critical;
          // chart top = top rect top left corner
          var topValue = data.chartRect.y1;

          // chart width
          var width = data.axisX.axisLength;
          // x coordinate of chart start
          var startX = data.chartRect.x1;

          var fontSize = 16;

          var styleProps = {
            successColor: "fill: #1cb987;",
            dangerColor: "fill: #ed145b;",
            warningColor: "fill: #ffbd5e;",
            rectOpacity: "opacity: 0.15;",
            fontSize: "font-size: " + fontSize + "px;",
          };

          // styles to be applied to rects
          var rectStyles = {
            success: styleProps.successColor + styleProps.rectOpacity,
            danger: styleProps.dangerColor + styleProps.rectOpacity,
            warning: styleProps.warningColor + styleProps.rectOpacity,
          };

          // classes to be added to rects
          var classes = {
            success: "success",
            danger: "danger",
            warning: "warning",
          };

          var textDetails = {
            successValue: "100%",
            dangerValue: "0%",
            successStyle: styleProps.successColor + styleProps.fontSize,
            dangerStyle: styleProps.dangerColor + styleProps.fontSize,
            textOffsetY: 20,
            offsetCorrection: fontSize / 2,
          };

          // height of the bottom rect
          var bottomHeight = data.axisY.projectValue(bottomValue);
          // y coordinate of the top left corner of bottom rect
          var bottomY = topValue - bottomHeight;
          // class of the bottom rect
          var bottomClass = options.above ? classes.danger : classes.success;

          data.svg.elem(
            "rect",
            {
              x: startX,
              y: bottomY,
              width: width,
              height: bottomHeight,
              style: options.above ? rectStyles.danger : rectStyles.success,
            },
            bottomClass,
            true
          );

          var bottomText = data.svg.elem(
            "text",
            {
              x: options.above
                ? width + textDetails.offsetCorrection
                : width - textDetails.offsetCorrection,
              y: bottomY + textDetails.textOffsetY,
              style: options.above
                ? textDetails.dangerStyle
                : textDetails.successStyle,
            },
            bottomClass,
            true
          );

          bottomText.text(
            options.above ? textDetails.dangerValue : textDetails.successValue
          );

          // if there is a critical target !== target then draw middle rect
          // see comments above for variables

          // setting middleHeight to 0, it will be changed only if there is a critical target
          var middleHeight = 0;

          if (middleValue) {
            middleHeight = data.axisY.projectValue(middleValue) - bottomHeight;
            var middleY = topValue - middleHeight - bottomHeight;

            data.svg.elem(
              "rect",
              {
                x: startX,
                y: middleY,
                width: width,
                height: middleHeight,
                style: rectStyles.warning,
              },
              classes.warning,
              true
            );
          } else {
            // do not add rect to chart
            // this one is probably not needed
            middleValue = bottomValue;
          }

          var topY = data.chartRect.y2;
          var topHeight = topValue - middleHeight - bottomHeight - topY;
          var topClass = options.above ? classes.success : classes.danger;

          data.svg.elem(
            "rect",
            {
              x: startX,
              y: topY,
              width: width,
              height: topHeight,
              style: options.above ? rectStyles.success : rectStyles.danger,
            },
            topClass,
            true
          );

          var topText = data.svg.elem(
            "text",
            {
              x: options.above
                ? width - textDetails.offsetCorrection
                : width + textDetails.offsetCorrection,
              y:
                topY +
                topHeight -
                textDetails.textOffsetY +
                textDetails.offsetCorrection,
              style: options.above
                ? textDetails.successStyle
                : textDetails.dangerStyle,
            },
            bottomClass,
            true
          );

          topText.text(
            options.above ? textDetails.successValue : textDetails.dangerValue
          );
        });
      }
    };
  };
});
